import React from 'react';
import type { CmsImage, CmsShortText } from '$cms/types';
import { Heading } from '$quantum/atoms/Heading';
import { Img } from '@/components/atoms/Img';
import styles from './index.module.scss';

interface ContactItemProps {
  icon: CmsImage;
  heading: CmsShortText;
  subHeading: React.ReactNode;
  extraElement?: React.ReactNode;
}
export function ContactItem({
  heading,
  icon: { alt, key, title, url },
  subHeading,
  extraElement,
}: ContactItemProps): JSX.Element {
  return (
    <div className={styles.contactItemContainer}>
      <div className={styles.contactItem}>
        <div className={styles.contactItemImageWrapper}>
          <Img provider="cloudinary" src={url} alt={alt} width={64} height={64} key={key} title={title} />
        </div>
        <div className={styles.contactItemInfo}>
          <Heading className={styles.contactItemInfoHeading}>{heading.value}</Heading>
          {subHeading}
        </div>
      </div>
      {extraElement}
    </div>
  );
}

ContactItem.displayName = 'ContactItem';
